import { cn } from '@/lib/utils';

// Equivalente ao LiveBadge do app Flutter — mostrado sempre que
// isEventLive(event._raw) é true (ver eventUtils.js), no Hero e nos cards
// de "Próximos Eventos". Badge verde sólido + bolinha branca pulsante,
// mesmo padrão visual (animate-ping) já usado no status "Acontecendo
// agora" da página de detalhe, só recolorido/reescrito pra bater com o
// LiveBadge do app ("Agora", verde sólido, não o pill translúcido).
export function LiveBadge({ className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold',
        'bg-emerald-500 text-white shadow-sm',
        className
      )}
    >
      <span className="relative flex h-1.5 w-1.5 flex-shrink-0">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white" />
      </span>
      Agora
    </span>
  );
}
